import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ModalGeneric } from '../../../../../ui/generics';
import { IVoucher } from '../../../core/interfaces/IVoucher';
import { VouchersService } from '../../../core/services/VouchersService';
import { finalize } from 'rxjs/operators';
import { VoucherSeriesTypes } from '../../../core/enums/VoucherSeriesTypes';
import { VoucherCodeStatuses } from '../../../core/enums/VoucherCodeStatuses';

@Component({
    selector: 'app-voucher-code-details-modal',
    templateUrl: './voucher-code-details-modal.component.html',
    styleUrls: ['./voucher-code-details-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VoucherCodeDetailsModalComponent extends ModalGeneric implements OnInit {

  public vouchers: IVoucher[] = [];
  public title = 'Details zum Gutscheincode';
  public isLoading = false;
  public readonly voucherSeriesTypes = VoucherSeriesTypes;
  public readonly voucherCodeStatuses = VoucherCodeStatuses;

  private _code: string;

  constructor(
    protected readonly cdr: ChangeDetectorRef,
    private readonly _vouchersService: VouchersService
  ) {
    super(cdr);
  }

  public ngOnInit(): void {}

  public showModal(object: { code: string; }) {
    super.showModal(object);

    this._code = object.code;
    this.loadVoucher();
  }

  public setVoucherAsSold(): void {
    this.isLoading = true;

    this._vouchersService.setVoucherAsSold(this.voucher.id).pipe(
      finalize(this.stopIsLoading.bind(this))
    ).subscribe(this.loadVoucher.bind(this));
  }

  public setVoucherAsRedeemed(): void {
    this.isLoading = true;

    this._vouchersService.setVoucherAsRedeemed(this.voucher.id).pipe(
      finalize(this.stopIsLoading.bind(this))
    ).subscribe(this.loadVoucher.bind(this));
  }

  public get voucher(): IVoucher {
    return this.vouchers[0];
  }

  private loadVoucher(): void {
    this.isLoading = true;

    this._vouchersService.getVoucherDetailsByCode(this._code).pipe(
      finalize(this.stopIsLoading.bind(this))
    ).subscribe(
      voucher => this.vouchers = voucher ? [voucher] : [],
      error => this.closeModal()
    );
  }

  private stopIsLoading(): void {
    this.isLoading = false;
    this.cdr.detectChanges();
  }
}
